<template>
  <div class="row">
    <div class="col-md-6 col-sm-12 col-12">
      <MarketSummaryDayWise
        @clickSectorRow="onClickSectorRow"
        :allStocks="allStocks"
        :marketDaily="marketDaily"
        :marketWeekly="marketWeekly"
        :marketMonthly="marketMonthly"
        :theme="theme"
        @emitSector="
          (emitData) => {
            emitSector = emitData;
          }
        "
      />
    </div>
    <div class="col-md-6 col-sm-12 col-12 q-mt-md q-mt-md-none q-pl-md-md">
      <StockPerformanceDayWise
        :selectedSectorId="selectedSectorId"
        :topLosersDaily="topLosersDaily"
        :topLosersWeekly="topLosersWeekly"
        :topLosersMonthly="topLosersMonthly"
        :topGainers="topGainers"
        :topGainersDaily="topGainersDaily"
        :topGainersWeekly="topGainersWeekly"
        :topGainersMonthly="topGainersMonthly"
        :allStocks="allStocks"
        :theme="theme"
      />
    </div>
  </div>
</template>

<script>
import { ref, watchEffect } from "vue";

import MarketSummaryDayWise from "src/components/MarketSummaryDayWise.vue";
import StockPerformanceDayWise from "./StockPerformanceDayWise.vue";

export default {
  name: "MarketSummaryAfterMarket",
  components: { MarketSummaryDayWise, StockPerformanceDayWise },
  props: {
    topLosersDaily: { type: Array },
    topLosersWeekly: { type: Array },
    topLosersMonthly: { type: Array },
    allStocks: { type: Array },
    topGainers: { type: Array },
    topGainersDaily: { type: Array },
    topGainersWeekly: { type: Array },
    topGainersMonthly: { type: Array },
    marketLive: { type: Array },
    marketDaily: { type: Array },
    marketWeekly: { type: Array },
    marketMonthly: { type: Array },
    theme: { type: Boolean, default: false },
  },
  emits: ["emitSector"],
  setup(props, context) {
    const selectedSectorId = ref(null);
    const emitSector = ref({});

    const onClickSectorRow = (emittedSector) => {
      selectedSectorId.value = emittedSector.sectorId;
    };
    watchEffect(() => {
      const newVal = emitSector.value;
      context.emit("emitSector", newVal);
    });

    return {
      selectedSectorId,
      onClickSectorRow,
      emitSector,
    };
  },
};
</script>
